const actionForceEndSequenceSchema = [
  {
    type: 'select',
    label: 'Target Sequence:',
    name: 'sequence_id',
    options: {},
    events: ['input'],
    validation: 'required',
    validationName: 'Target Sequence'
  },
]

const actionForceEndSequenceValue = {
  type: 'action_force_end_sequence',
  sequence_id: null,
  wait_until_finished: false,
}

export { actionForceEndSequenceSchema, actionForceEndSequenceValue }
